<template>
  <div>
    <component
      :is="'qr-holder'"
      :prefix="prefix"
      :value="code"
      :message="'Scan this in Tallyflow Mobile to associate a handheld with this endpoint.'"
    >
    </component>
  </div>
</template>

<script>
import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      info: {
        _id: '',
        key: ''
      },
      prefix: '',
      code: ''
    }
  },

  created () {
    if (this.$route.params.id) {
      ApiRequests.getEndpoint(this.$route.params.id).then(r => {
        this.info = r.data
        this.code = 'id:' + r.data._id + ' key:' + r.data.key
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/EndpointQRCode.vue